import type { Academy } from '@court-sync/shared';

/** Calendar "today" for past-session checks: prefer academy IANA timezone, else UTC (ISO date). */
export function ymdTodayForAcademy(
  academy: Pick<Academy, 'timezone'> | null | undefined
): string {
  const tz = academy?.timezone?.trim();
  const now = new Date();
  if (tz) {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(now);
    } catch {
      // fall through to UTC
    }
  }
  return now.toISOString().slice(0, 10);
}

export function isSessionDateBeforeAcademyToday(
  sessionDateYmd: string,
  academy: Pick<Academy, 'timezone'> | null | undefined
): boolean {
  return sessionDateYmd < ymdTodayForAcademy(academy);
}
